import Vue from 'vue'

Vue.mixin({
  methods: {
    getLocale(slug) {
      console.log('Slug: ', slug)
    },
  },
})
